export default __webpack_public_path__ + "static/media/Tigers.fd0bb331.png";